/* global fetchSupplierContractsTermsUrl, downloadSupplierContractsTermAttachmentUrl suppliersIndexUrl */

import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';
import moment from 'moment';

import SupplierContractTermMilestonesTable from './SupplierContractTermMilestonesTable';
import SupplierContractTermNotesTable from './SupplierContractTermNotesTable';
import SupplierContractTermPartiesTable from './SupplierContractTermPartiesTable';

function SupplierContractTermsIndex() {
    const [terms, setTerms] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => fetchTerms(), []);

    const fetchTerms = () => {
        setIsLoading(true);
        axios
            .get(fetchSupplierContractsTermsUrl)
            .then(({ data }) => setTerms(data))
            .catch((error) => {})
            .finally(() => setIsLoading(false));
    };

    const download = (e, attachment) => {
        e.preventDefault();
        const url = downloadSupplierContractsTermAttachmentUrl.replace('ATTACHMENT_ID', attachment.id);

        axios({
            url: url,
            method: 'GET',
            responseType: 'blob',
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', attachment.file_name);
            document.body.appendChild(link);
            link.click();
        });
    };

    if (isLoading) {
        return <div>Loading ...</div>;
    } else if (!terms) {
        return <div className="text-danger">{$t('Something went wrong')}.</div>;
    }

    return (
        <div>
            <div className="card bg-white border-0 rounded-15px shadow my-4">
                <div className="card-body">
                    <h5 className="card-title">{$t('General Terms')}</h5>
                    <div className="row">
                        <div className="col-6">
                            <div className="text-primary font-weight-bold">{$t('Owner Info')}</div>
                            <table className="table table-borderless no-footer">
                                <tbody>
                                    <tr>
                                        <td style={{ width: '30%' }} className="p-0">
                                            {$t('Name')}
                                        </td>
                                        <td className="text-primary font-weight-bold p-1">
                                            {terms.owner?.first_name} {terms.owner?.last_name}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: '30%' }} className="p-0">
                                            {$t('Email')}
                                        </td>
                                        <td className="text-primary font-weight-bold p-1">{terms.owner?.email}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="col-6">
                            <div className="text-primary font-weight-bold">{$t('Supplier Information')}</div>
                            <table className="table table-borderless no-footer">
                                <tbody>
                                    <tr>
                                        <td style={{ width: '30%' }} className="p-0">
                                            {$t('Name')}
                                        </td>
                                        <td className="text-primary font-weight-bold p-1">{terms.contact_name}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: '30%' }} className="p-0">
                                            {$t('Email')}
                                        </td>
                                        <td className="text-primary font-weight-bold p-1">{terms.contact_email}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="col-6">
                            <div className="text-primary font-weight-bold">{$t('Overview')}</div>
                            <table className="table table-borderless no-footer">
                                <tbody>
                                    <tr>
                                        <td style={{ width: '30%' }} className="p-0">
                                            {$t('Scope of supply')}
                                        </td>
                                        <td className="text-primary font-weight-bold p-1" style={{ whiteSpace: 'pre-wrap' }}>
                                            {terms.supply_scope}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: '30%' }} className="p-0 tw-capitalize">
                                            {$t('Contract Start Date')}
                                        </td>
                                        <td className="text-primary font-weight-bold p-1">
                                            {terms.start_date && moment(terms.start_date).format('YYYY-MM-DD')}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: '30%' }} className="p-0">
                                            {$t('Contract end date')}
                                        </td>
                                        <td className="text-primary font-weight-bold p-1">{terms.end_date && moment(terms.end_date).format('YYYY-MM-DD')}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="col-6">
                            <div className="text-primary font-weight-bold">{$t('Attachments')}</div>
                            <ul>
                                {terms.attachments?.length ? (
                                    terms.attachments.map((attachment) => {
                                        return (
                                            <li key={`attachment_${attachment.id}`}>
                                                <a href={''} onClick={(e) => download(e, attachment)}>
                                                    {attachment.file_name}
                                                </a>
                                            </li>
                                        );
                                    })
                                ) : (
                                    <div className="text-info">{$t('This terms has no attachments')}</div>
                                )}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div className="card bg-white border-0 rounded-15px shadow my-4">
                <div className="card-body">
                    <h5 className="card-title">{$t('Key Personnel')}</h5>
                    <SupplierContractTermPartiesTable parties={terms.parties} suppliersIndexUrl={suppliersIndexUrl} />
                </div>
            </div>
            <div className="card bg-white border-0 rounded-15px shadow my-4">
                <div className="card-body">
                    <h5 className="card-title">{$t('Penalty Clauses')}</h5>
                    {terms.penalties?.length ? (
                        <ul>
                            {terms.penalties.map((penalty) => (
                                <li key={penalty.id} className="text-primary font-weight-bold p-1">
                                    {penalty.description}
                                </li>
                            ))}
                        </ul>
                    ) : (
                        <div className="text-info">{$t('This contract has no penalty clauses')}</div>
                    )}
                </div>
            </div>
            <div className="card bg-white border-0 rounded-15px shadow my-4">
                <div className="card-body">
                    <h5 className="tw-text-blue tw-text-2xl tw-font-semibold tw-mb-6">{$t('Payment milestones')}</h5>
                    <SupplierContractTermMilestonesTable milestones={terms.payments} hasAmount />
                </div>
            </div>
            <div className="card bg-white border-0 rounded-15px shadow my-4">
                <div className="card-body">
                    <h5 className="tw-text-blue tw-text-2xl tw-font-semibold tw-mb-6">{$t('Other milestones')}</h5>
                    <SupplierContractTermMilestonesTable milestones={terms.milestones} />
                </div>
            </div>
            <div className="card bg-white border-0 rounded-15px shadow my-4">
                <div className="card-body">
                    <h5 className="tw-text-blue tw-text-2xl tw-font-semibold tw-mb-6">{$t('Notes')}</h5>
                    <SupplierContractTermNotesTable notes={terms.notes} />
                </div>
            </div>
        </div>
    );
}

export default SupplierContractTermsIndex;
if (document.getElementById('SupplierContractTermsIndex')) {
    var rootEl = document.getElementById('SupplierContractTermsIndex');
    ReactDOM.render(
        <App>
            <SupplierContractTermsIndex />
        </App>,
        rootEl,
    );
}
